import { createReducer, on } from '@ngrx/store';

import { setLoadedProductDiscounts } from '../actions/prices.actions';
import { State } from '../models/state';

export const initialState: State = {};

export const reducer = createReducer(
  initialState,
  on(setLoadedProductDiscounts, (_, { type, ...discounts }) => ({
    ...discounts,
  })),
);
